import { HardDrive, Shield } from 'lucide-react';

export function Security() {
  return (
    <section className="bg-white py-20 sm:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-xl text-center mb-12">
          <h2 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl">
            Your Data Never Leaves Your Control
          </h2>
        </div>

        <div className="mx-auto max-w-5xl">
          {/* Deidentification Image */}
          <div className="mb-12">
            <img
              src="/deidentification.jpg"
              alt="SafeIdea deidentification: Client data stays on your PC, only sanitized queries reach cloud AI"
              className="w-full rounded-lg shadow-lg"
            />
          </div>

          <div className="grid gap-8 md:grid-cols-2">
            {/* Native Desktop App */}
            <div className="rounded-lg border border-gray-200 bg-gray-50 p-8">
              <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-blue-100">
                <HardDrive className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="mb-3 text-2xl font-semibold text-gray-900">
                Native Desktop Application
              </h3>
              <ul className="space-y-2 text-lg text-gray-600">
                <li className="flex items-start gap-2">
                  <span className="mt-1 text-blue-600">✓</span>
                  <span>Runs locally on Windows and Mac</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 text-blue-600">✓</span>
                  <span>All work product stored on your PC only</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 text-blue-600">✓</span>
                  <span>Not multi-tenant—no shared cloud infrastructure</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 text-blue-600">✓</span>
                  <span>Complete control over your data</span>
                </li>
              </ul>
            </div>

            {/* Patent-Pending Deidentification */}
            <div className="rounded-lg border border-gray-200 bg-gray-50 p-8">
              <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-blue-100">
                <Shield className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="mb-3 text-2xl font-semibold text-gray-900">
                Patent-Pending Deidentification
              </h3>
              <ul className="space-y-2 text-lg text-gray-600">
                <li className="flex items-start gap-2">
                  <span className="mt-1 text-blue-600">✓</span>
                  <span>Strips PII, names, dates, locations before transmission</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 text-blue-600">✓</span>
                  <span>Only sanitized, anonymized queries reach cloud AI</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 text-blue-600">✓</span>
                  <span>Original documents never leave your machine</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 text-blue-600">✓</span>
                  <span>Full audit trail of all AI interactions</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
